import React from 'react';
import { Github, Linkedin, Instagram, GraduationCap, Code, BookOpen, Briefcase } from 'lucide-react';
import { profileData } from '../data/mock';
import { Button } from './ui/button';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';

const Hero = () => {
  const getIcon = (iconName) => {
    if (iconName === 'linkedin') return Linkedin;
    if (iconName === 'github') return Github;
    if (iconName === 'instagram') return Instagram;
    if (iconName === 'graduation-cap') return GraduationCap;
    if (iconName === 'code') return Code;
    if (iconName === 'book-open') return BookOpen;
    if (iconName === 'briefcase') return Briefcase;
    return Code;
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center pt-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        {/* Profile Image */}
        <div className="mb-8 flex justify-center">
          <Avatar className="h-40 w-40 border-4 border-primary shadow-lg overflow-hidden">
            <AvatarImage 
              src={profileData.profileImage} 
              alt={profileData.name} 
              className="object-cover object-center"
            />
            <AvatarFallback className="text-4xl">Zai</AvatarFallback>
          </Avatar>
        </div>

        {/* Greeting */}
        <div className="mb-4 text-xl text-muted-foreground">
          👋 Hi, I'm
        </div>

        {/* Name and Title */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-foreground mb-4">
          {profileData.name}
        </h1>
        <p className="text-xl sm:text-2xl text-muted-foreground mb-8">
          {profileData.title}
        </p>

        {/* Social Links Grid */}
        <div className="grid grid-cols-4 gap-3 sm:gap-4 max-w-md mx-auto mb-12">
          {profileData.socialLinks.map((link) => {
            const IconComponent = getIcon(link.icon);
            return (
              <a
                key={link.id}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group"
              >
                <div className="flex flex-col items-center p-3 rounded-lg border border-border bg-card hover:bg-accent hover:border-primary transition-all duration-300 hover:scale-105">
                  <IconComponent className="h-6 w-6 mb-2 text-muted-foreground group-hover:text-primary transition-colors" />
                  <span className="text-xs text-muted-foreground group-hover:text-foreground truncate w-full text-center">
                    {link.name.split(' ')[0]}
                  </span>
                </div>
              </a>
            );
          })}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            size="lg"
            onClick={() => {
              const el = document.querySelector('#projects');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-base"
          >
            View Projects
          </Button>
          <Button
            size="lg"
            variant="outline"
            asChild
            className="text-base"
          >
            <a href={`mailto:${profileData.email}`}>
              Contact Me
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
